<template>
  <div class="entry-list">
    <van-tabs v-model="role" @change="onClick">
      <van-tab title="我的报名" :name="1"></van-tab>
      <van-tab title="我的参赛" :name="0"></van-tab>
    </van-tabs>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="teams" v-if="teams.length > 0">
        <div class="team" v-for="(item, index) in teams" :key="index">
          <div class="top">
            <div class="left">
              <div class="status-team-name">
                <span class="status _0" v-if="item.isSubmit === 0">未提交</span>
                <span class="status _0" v-else-if="item.auditStatus === 0 || item.auditStatus === 1">待确认</span>
                <span class="status _1" v-else-if="item.auditStatus === 3">已锁定</span>
                <span class="status _2" v-else-if="item.auditStatus === 2">已确认</span>
                <span class="status _3" v-else-if="item.auditStatus === -1">已退回</span>
                <span class="team-name" v-if="item.role === 1">{{ item.name }}</span>
                <span class="team-name" v-else>{{ item.trueName }}</span>
              </div>
              <div class="row" v-if="item.role === 1">
                <span class="group">{{ item.chineseName }}</span>
              </div>
              <div class="row" v-else>
                <div class="group">{{ item.name }}({{ getPartByIndex(item.chineseName, 1) }})</div>
                <div class="group">{{ getPartByIndex(item.chineseName, 0) }}</div>
              </div>
            </div>
            <div class="right"
              v-if="item.role === 0 && item.isSubmit === 1 && (item.isOpenCharge === 0 || item.feeMethod === 0 || item.orderStatus === 1 || item.orderStatus === 2)"
              @click="goEntryCertificate(item)">
              <img src="../../../assets/entry-list/001.png" style="width: 36px; height: 30px; border-radius: 4px" alt="">
            </div>
          </div>
          <div style="font-size: 14px;" v-if="item.auditStatus === -1 && item.auditRemark" @click="openRemark(item)">
            查看退回理由</div>
          <div class="line"></div>
          <div class="bottom">
            <div class="row" v-if="item.role === 0">
              <van-button style="margin-left: 12px" type="info" round @click="goTransfer(item)" class="buttom-item"
                v-if="item.teamLeaderTransferOpen === 1 && role === 1">
                <span style="font-size: 12px">移交领队</span>
              </van-button>
              <van-button @click="cancelBMMatchTeamPlayer(item)"
                v-if="(item.auditStatus === 0 || item.auditStatus === 1) && item.teamLeaderAddPlayerOnly === 0" round
                type="default" plain class="buttom-item">
                <span style="font-size: 12px">取消报名</span>
              </van-button>
              <van-button @click="editPlayer(item)" :disabled="isDisabledAdjust"
                v-if="item.isSubmit === 0 && item.teamLeaderAddPlayerOnly === 0" round type="default"
                style="margin-left: 12px" plain class="buttom-item">
                <span style="font-size: 12px">编 辑</span>
              </van-button>
              <van-button @click="doPay(item)"
                v-if="item.isOpenCharge === 1 && item.feeMethod === 1 && item.orderStatus !== 1 && item.orderStatus !== 2"
                round type="default" style="margin-left: 12px" plain class="buttom-item">
                <span style="font-size: 12px">付 款</span>
              </van-button>
            </div>
            <div class="row" v-if="item.role === 1">
              <van-button style="margin-left: 12px" type="info" round @click="goTransfer(item)" class="buttom-item"
                v-if="item.teamLeaderTransferOpen === 1 && role === 1">
                <span style="font-size: 12px">移交领队</span>
              </van-button>
              <van-button @click="cancelBMMatchTeam(item)" v-if="item.auditStatus === -1" round type="default" plain
                class="buttom-item">
                <span style="font-size: 12px">取消报名</span>
              </van-button>
              <van-button @click="doPay(item)"
                v-if="item.isOpenCharge === 1 && item.isSubmit === 1 && (item.feeMethod === 2 || item.feeMethod === 3) && item.orderStatus !== 1 && item.orderStatus !== 2"
                round type="default" style="margin-left: 12px" plain class="buttom-item">
                <span style="font-size: 12px">付 款</span>
              </van-button>
              <van-button @click="adjustTeamInfo(item)" :disabled="isDisabledAdjust"
                v-if="(item.auditStatus !== 2) && (item.isSubmit === 0 || item.auditStatus === -1)" round type="info"
                style="margin-left: 12px" class="buttom-item">
                <span style="font-size: 12px">名单调整</span>
              </van-button>
              <van-button v-else round type="info" style="margin-left: 12px" @click="adjustTeamInfo(item)"
                class="buttom-item">
                <span style="font-size: 12px">详情</span>
              </van-button>
              <van-button @click="updateBMMatchTeam(item)" :disabled="isDisabledSubmit"
                v-if="item.isSubmit === 0 || item.auditStatus === -1" round type="info" style="margin-left: 12px"
                class="buttom-item">
                <span style="font-size: 12px">提交报名</span>
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <van-empty v-else description="暂无报名" />
    </van-pull-refresh>
  </div>
</template>

<script>
import Vue from 'vue'
import { Image as VanImage, Button, Dialog, Toast, Empty, Tabs, Tab, PullRefresh, DropdownMenu, DropdownItem } from 'vant'
Vue.use(VanImage).use(Button).use(Empty).use(Tabs).use(Tab).use(PullRefresh).use(DropdownMenu).use(DropdownItem)
import {
  bangsaishiCreatePlayerSignupOrder,
  bangsaishiCreateTeamSignupOrder,
  cancelBMMatchTeam,
  cancelBMMatchTeamPlayer,
  checkBMMatchBeforeSubmit, getBMMatchOrderListByUser,
  getBMUnionMatch,
  getMatchTeamListByUser,
  submitBMMatchTeam
} from "@/api/match";
import { DateUtil, QNImageUtil } from '@/utils';
import { getPassport } from "@/libs/passport";

export default {
  data() {
    return {
      unionMatchId: '',
      match: {},
      teams: [],
      isLoading: false,
      orderIndex: 0,
      role: 1
    }
  },
  mounted() {
    getPassport().then(res => {
      if (res) {
        const role = this.$route.query.role || 1
        this.role = Number(role)
        this.unionMatchId = this.$route.query.unionMatchId
        this.getBMUnionMatch()
        this.getMatchTeamListByUser()
        this.getBMMatchOrderListByUser()
      }
    })
  },
  computed: {
    isDisabledAdjust() {
      if (!this.match.regUpdateEndDate) return false
      let now = new Date().getTime()
      let deadline = new Date(this.match.regUpdateEndDate).getTime()
      return now >= deadline
    },
    isDisabledSubmit() {
      if (!this.match.regEndDate) return false
      let now = new Date().getTime()
      let deadline = new Date(this.match.regEndDate).getTime()
      return now >= deadline
    },
  },
  methods: {
    goTransfer(obj) {
      // const badge = 'FrB9e_-z4Gj4879NuraIWmiVDkv_'
      // console.log(obj);
      this.$router.push(`/entry-page/transfer-captain?matchId=${obj.matchId}&teamId=${obj.teamId}`)
    },
    getBMMatchOrderListByUser() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMMatchOrderListByUser(params).then(res => {
        if (res) {
          const data = res.data
          const list = data.list || []
          const l = list.find(item => item.orderStatus === 0)
          console.log(l);
          
          if (l) {
            Dialog.confirm({
              title: '尚未支付',
              message: '有订单尚未支付',
              cancelButtonText: '我再想想',
              confirmButtonText: '前往支付'
            }).then(() => {
              const category = l.feeMethod === 1 ? 1 : 0
              const objId = l.objId.split('%')
              this.$router.push(`/entry-page/payment?orderId=${l.orderId}&unionMatchId=${this.unionMatchId}&category=${category}&matchId=${objId[0]}&teamId=${objId[1]}`)
            })
          }
        }
      })
    },
    getPartByIndex(s, i) {
      if (!s) return ''
      const arr = s.split('_')
      if (arr.length > i) return arr[i]
      return ''
    },
    editPlayer(item) {
      this.$router.push({ path: '/entry-page/update-player', query: { unionMatchId: this.unionMatchId, matchId: item.matchId, teamId: item.teamId, playerId: item.playerId } })
    },
    onClick() {
      this.getMatchTeamListByUser()
    },
    openRemark(item) {
      Dialog.confirm({
        title: '退回理由',
        message: item.auditRemark,
        confirmButtonText: '前往修改',
        cancelButtonText: '我知道了'
      }).then(() => {
        // on confirm
        this.adjustTeamInfo(item)
      }).catch(() => {
        // on cancel
      });
    },
    onRefresh() {
      this.getMatchTeamListByUser()
    },
    cancelBMMatchTeamPlayer(item) {
      if (item.orderStatus === 1 || item.orderStatus === 2) {
        Toast.fail('已支付报名费用，取消报名请联系组委会')
        return
      }
      Dialog.confirm({
        title: '取消确认',
        message: `是否确定要取消${item.name}下的参赛报名`,
      }).then(() => {
        const params = {
          matchId: item.matchId,
          teamId: item.teamId,
          playerId: item.playerId
        }
        cancelBMMatchTeamPlayer(params).then(res => {
          if (res) {
            this.getMatchTeamListByUser()
          }
        })
      })
    },
    doPay(item) {
      const regEndDate = this.match.regEndDate || ''
      const regUpdateEndDate = this.match.regUpdateEndDate || ''
      if (regEndDate && regUpdateEndDate) {
        if (new Date().getTime() > new Date(regEndDate).getTime() && new Date().getTime() > new Date(regUpdateEndDate).getTime()) {
          Toast('报名已截止，请联系组委会')
          return
        }
      } else if (regEndDate) {
        if (new Date().getTime() > new Date(regEndDate).getTime()) {
          Toast('报名已截止，请联系组委会')
          return
        }
      } else if (regUpdateEndDate) {
        if (new Date().getTime() > new Date(regUpdateEndDate).getTime()) {
          Toast('报名已截止，请联系组委会')
          return
        }
      }
      const params = {
        matchId: item.matchId,
        teamId: item.teamId
      }
      if (item.role === 0) {
        params.playerId = item.playerId
        bangsaishiCreatePlayerSignupOrder(params).then(res => {
          if (res) {
            this.$router.push(`/entry-page/payment?orderId=${res.data.orderId}&unionMatchId=${this.unionMatchId}&category=1&matchId=${item.matchId}&teamId=${item.teamId}&playerId=${item.playerId}`)
          }
        })
      } else if (item.role === 1) {
        bangsaishiCreateTeamSignupOrder(params).then(res => {
          if (res) {
            this.$router.push(`/entry-page/payment?orderId=${res.data.orderId}&unionMatchId=${this.unionMatchId}&category=0&matchId=${item.matchId}&teamId=${item.teamId}`)
          }
        })
      }

    },
    updateBMMatchTeam(item) {
      if (item.isOpenCharge === 1 && (item.feeMethod === 2 || item.feeMethod === 3) && item.orderStatus !== 1 && item.orderStatus !== 2) {
        /**
         * 先校验
         * TODO
         */
        const params = {
          teamId: item.teamId,
          matchId: item.matchId
        }
        checkBMMatchBeforeSubmit(params).then(res => {
          if (res) {
            Dialog.confirm({
              title: '尚未支付',
              message: '尚未支付，请前往支付费用',
            }).then(() => {
              const params = {
                matchId: item.matchId,
                teamId: item.teamId
              }
              bangsaishiCreateTeamSignupOrder(params).then(res => {
                if (res) {
                  this.$router.push(`/entry-page/payment?orderId=${res.data.orderId}&unionMatchId=${this.unionMatchId}&category=0&matchId=${item.matchId}&teamId=${item.teamId}`)
                }
              })
            })
          }
        })
      } else {
        checkBMMatchBeforeSubmit({
          teamId: item.teamId,
          matchId: item.matchId
        }).then(res => {
          if (res) {
            const params = {
              teamId: item.teamId,
              matchId: item.matchId
            }
            submitBMMatchTeam(params).then(res => {
              if (res) {
                Toast('提交成功')
                this.getMatchTeamListByUser()
              }
            })
          }
        })
      }
    },
    goMatchDetail(item) {
      this.$router.push(`/match/home?matchId=${item.matchId}`)
    },
    goEntryCertificate(item) {
      this.$router.push(`/entry-page/entry-certificate/${item.matchId}?playerId=${item.playerId}`)
    },
    imgView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getFormatDate(date, type) {
      if (!type) type = '{y}-{m}-{d}'
      return DateUtil.parseDateTime(date, type)
    },
    getBMUnionMatch() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMUnionMatch(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match || {}
          document.title = data.match.chineseName
          const shareObj = {
            title: this.match.chineseName,
            abstract: '我的报名',
            image: QNImageUtil.imageView(this.match.icon)
          }
          this.wxShare(shareObj)
        }
      })
    },
    getMatchTeamListByUser() {
      const params = {
        unionMatchId: this.unionMatchId,
        role: this.role,
        orderIndex: this.orderIndex
      }
      getMatchTeamListByUser(params).then(res => {
        if (res) {
          const data = res.data
          this.teams = data.list
          this.isLoading = false
          const user = data.user || {}
          if (!user.mobile) {
            Dialog.alert({
              title: '您还没有关联手机号',
              message: '关联手机号后，可查看电子参赛证，获取看更多赛事信息',
            }).then(() => {
              this.$router.push('/entry-page/correlate-mobile')
            })
          }
        }
      })
    },
    deleteBMMatchTeam(item) {
      Dialog.confirm({
        title: '是否删除报名',
        message: '删除报名后，数据将丢失',
      }).then(() => {
        const params = {
          matchId: item.matchId,
          teamId: item.teamId
        }
        cancelBMMatchTeam(params).then(res => {
          if (res) {
            Toast.success('删除成功')
            this.getMatchTeamListByUser()
          }
        })
      })
    },
    cancelBMMatchTeam(item) {
      if (item.isOpenCharge === 1 && item.feeMrthods === 1 && item.isOpenCharge > 0) {
        Dialog.alert({
          title: '取消失败',
          message: '已有队员支付报名费用，取消报名请联系组委会',
        })
        return
      }
      Dialog.confirm({
        title: '是否取消报名',
        message: '取消后，数据将丢失',
      }).then(() => {
        const params = {
          matchId: item.matchId,
          teamId: item.teamId
        }
        cancelBMMatchTeam(params).then(res => {
          if (res) {
            Toast.success('取消成功')
            this.getMatchTeamListByUser()
          }
        })
      })
    },
    adjustTeamInfo(item) {
      if (item.unitType === 0) {
        this.$router.push({ path: '/entry-page/entry-info', query: { unionMatchId: this.unionMatchId, matchId: item.matchId, teamId: item.teamId } })
      } else if (item.unitType === 1) {
        this.$router.push({ path: '/entry-page/entry-info-person', query: { unionMatchId: this.unionMatchId, matchId: item.matchId, teamId: item.teamId } })
      } else if (item.unitType === 2) {
        this.$router.push({ path: '/entry-page/entry-info-more', query: { unionMatchId: this.unionMatchId, matchId: item.matchId, teamId: item.teamId } })
      }
    }
  }
}
</script>

<style lang="scss">
.entry-list {
  .match {
    background-color: #fff;
    border-radius: 4px 4px 8px 8px;
    margin-bottom: 12px;

    .info {
      margin: 0 16px;
      padding: 16px 0 12px 0;
      display: flex;
      flex-flow: row;

      .left {
        text-align: center;
        width: 44px;

        .care {
          width: 44px;
          height: 20px;
          border-radius: 2px;
          background-color: #BEF002;
          color: #191919;
          font-size: 12px;
          line-height: 20px;
          text-align: center;
          margin-top: 12px;
        }
      }

      .right {
        width: calc(100% - 36px);
        padding-left: 12px;
        box-sizing: border-box;

        .title {
          height: 48px;
          font-size: 18px;
          font-weight: 500;
          color: #191919;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }

        .address {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #999999;
        }

        .size-count {
          margin-top: 4px;
          display: flex;
          flex-flow: row;
          font-size: 12px;
          color: #474747;

          .count {
            margin-left: 12px;
          }
        }
      }
    }
  }

  .teams {
    padding: 16px 16px 20px 16px;

    .team {
      padding: 16px 12px 12px 12px;
      margin-bottom: 12px;
      background-color: #F8F8F8;
      border-radius: 4px;

      .top {
        display: flex;
        justify-content: space-between;

        .left {
          .status-team-name {
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;

            .status {
              color: #FFFFFF;
              border-radius: 2px;
              display: inline-block;
              height: 20px;
              width: 48px;
              line-height: 20px;
              font-size: 12px;
              text-align: center;
            }

            ._0 {
              background-color: #0ABB58;
            }

            ._1 {
              background-color: #333333;
            }

            ._2 {
              background-color: #0ABB58;
            }

            ._3 {
              background-color: #F95252;
            }

            .team-name {
              font-size: 16px;
              height: 20px;
              color: #333333;
              margin-left: 4px;
            }
          }

          .row {
            padding: 5px 0;

            .group {
              font-size: 14px;
              color: #333333;
            }
          }
        }

        .right {
          width: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .line {
        margin: 4px 0 12px 0;
        height: 1px;
        background-color: #F3F3F3;
      }

      .bottom {
        .row {
          display: flex;
          justify-content: right;

          .buttom-item {
            width: 90px;
            height: 28px;
          }
        }
      }
    }
  }
}
</style>
